import React, { useEffect, useState } from 'react';
import axios from 'axios';
import IconBoxStyle11 from '../../IconBox/IconBoxStyle11';
import Spacing from '../../Spacing';
import { BASE_URL } from '../../../helpers/api';

const DEFAULT_SETTINGS = {
  phone: '+91 9876543210',
  whatsapp: '',
  email: 'info@medayus.com',
};

export default function ContactInfoSection({ sectionTitle }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/settings`)
      .then((res) => {
        if (res.data && Object.keys(res.data).length) {
          setSettings((prev) => ({ ...prev, ...res.data }));
        }
      })
      .catch(() => {
        // keep DEFAULT_SETTINGS
      });
  }, []);

  const phoneDigits = (settings.phone || '').replace(/[^\d+]/g, '');
  const whatsappDigits = (settings.whatsapp || '').replace(/[^\d]/g, '');

  return (
    <div className="container">
      <h2 className="cs_fs_72 mb-0">{sectionTitle}</h2>
      <Spacing md="20" lg="10" />
      <div className="row g-4 g-xl-3 g-xxl-5">
        {settings.phone && (
          <div className="col-xl-4">
            <IconBoxStyle11
              title="Phone"
              subTitle={settings.phone}
              iconSrc="/images/contact/icon_1.svg"
              href={`tel:${phoneDigits}`}
            />
          </div>
        )}
        {whatsappDigits && (
          <div className="col-xl-4">
            <IconBoxStyle11
              title="WhatsApp"
              subTitle={settings.whatsapp}
              iconSrc="/images/contact/icon_whatsapp.svg"
              iconStyle={{ width: '78px', height: '78px' }}
              href={`https://wa.me/${whatsappDigits}`}
            />
          </div>
        )}
        {settings.email && (
          <div className="col-xl-4">
            <IconBoxStyle11
              title="Email"
              subTitle={settings.email}
              iconSrc="/images/contact/icon_2.svg"
              href={`mailto:${settings.email}`}
            />
          </div>
        )}
      </div>
      <Spacing md="5" />
    </div>
  );
}
